define("shared/modifiers/droppable", ["exports", "@ember/service", "ember-modifier"], function (_exports, _service, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let DroppableModifier = _exports.default = (_class = class DroppableModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _defineProperty(this, "dragEnter", event => {
        if (typeof this.onDragEnter === 'function') {
          this.onDragEnter(event);
        }
      });
      _defineProperty(this, "dragOver", event => {
        event.preventDefault();
        if (this.cssClassName) {
          const target = event.target;
          target?.classList.add(this.cssClassName);
        }
      });
      _defineProperty(this, "dragLeave", event => {
        if (this.cssClassName && this.domElement === this.element) {
          this.domElement.classList.remove(this.cssClassName);
        }
        if (typeof this.onDragLeave === 'function') {
          this.onDragLeave(event);
        }
      });
      _defineProperty(this, "drop", event => {
        try {
          if (typeof this.onDrop === 'function') {
            this.onDrop(event);
          } else if (this.onDrop?.state) {
            this.onDrop.perform(event);
          }
          const target = event.target;
          this.cssClassName && target?.classList.remove(this.cssClassName);
        } catch (error) {
          this.alerts.warning(error);
        }
      });
    }
    get domElement() {
      return this.args.named.isWindow ? window : this.element;
    }
    get onDragEnter() {
      return this.args.named.onDragEnter;
    }
    get onDragLeave() {
      return this.args.named.onDragLeave;
    }
    get onDrop() {
      return this.args.named.onDrop;
    }
    get cssClassName() {
      return this.args.named.cssClassName;
    }
    didReceiveArguments() {
      this.domElement.addEventListener('dragenter', this.dragEnter);
      this.domElement.addEventListener('dragover', this.dragOver);
      this.domElement.addEventListener('dragleave', this.dragLeave);
      this.domElement.addEventListener('drop', this.drop);
    }
    willDestroy() {
      this.domElement.removeEventListener('dragenter', this.dragEnter);
      this.domElement.removeEventListener('dragover', this.dragOver);
      this.domElement.removeEventListener('dragleave', this.dragLeave);
      this.domElement.removeEventListener('drop', this.drop);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});